module.exports = __webpack_public_path__ + "img/2f_r_bajitofu@2x.a6301457.png";